import { render, staticRenderFns } from "./VehicleLogging.vue?vue&type=template&id=46aa184a&scoped=true"
import script from "./VehicleLogging.vue?vue&type=script&lang=js"
export * from "./VehicleLogging.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46aa184a",
  null
  
)

export default component.exports